// Import Core
import { useState } from 'react';

const useSlideInMap = () => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  const toggleMap = () => {
    setIsMapOpen(!isMapOpen);
    document.getElementById('map-wrapper').classList.toggle('slide');

    // console.log('map opening');
    
    // // If close btn on actual map is clicked we need to trigger a click on the 'Close Map' button so it resets to say 'Map'
    // let sectionTitleMapBtn = document.querySelector('.map .slide-in-map-btn');
		// sectionTitleMapBtn.click();

  }

  return [
    isMapOpen,
    toggleMap
  ]

};

export default useSlideInMap;